import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-notificator-item-image"
}
const _hoisted_3 = { class: "gfu-notificator-item-image-box" }
const _hoisted_4 = { class: "gfu-notificator-item-image-box-inner" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "gfu-notificator-item__title"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "gfu-notificator-item__message",
  "data-qa": "notificator-message"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["data-qa"]
const _hoisted_11 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.notificatorClassList),
    "data-qa": $options.qaKey
  }, [
    ($options.hasImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                class: "_fo",
                src: $props.imageUrl,
                alt: $props.title
              }, null, 8 /* PROPS */, _hoisted_5)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", null, [
      ($props.title)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString($props.title), 1 /* TEXT */),
            _createTextVNode(_toDisplayString($props.titlePostfix), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      ($options.shouldSplitMessageAndTitle)
        ? (_openBlock(), _createElementBlock("br", _hoisted_7))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString($props.message), 1 /* TEXT */)
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "actions", {}, () => [
      ($props.action)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ($props.action.callback)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _cache[2] || (_cache[2] = _createTextVNode("(", -1 /* CACHED */)),
                  _createElementVNode("a", {
                    class: "gfu-link gfu-link--emphasized",
                    href: "",
                    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($props.action.callback && $props.action.callback(...args)), ["prevent"])),
                    "data-qa": `notificator-button:${$props.action.title}`
                  }, _toDisplayString($props.action.title), 9 /* TEXT, PROPS */, _hoisted_10),
                  _cache[3] || (_cache[3] = _createTextVNode(")", -1 /* CACHED */))
                ]))
              : ($props.action.route)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _cache[4] || (_cache[4] = _createTextVNode("(", -1 /* CACHED */)),
                    _createVNode(_component_router_link, {
                      class: "gfu-link gfu-link--emphasized",
                      to: $props.action.route
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($props.action.title), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"]),
                    _cache[5] || (_cache[5] = _createTextVNode(")", -1 /* CACHED */))
                  ]))
                : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($props.canClose)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "gfu-notificator-item__close-button",
          onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onClose && $options.onClose(...args)), ["prevent"])),
          "data-qa": "notificator-close-btn"
        }, [
          _createVNode(_component_base_icon, { name: "times" })
        ]))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}